<template>
  <div class="bg-gray overflow-auto q-mb-md">
    <div class="row q-col-gutter-md q-px-md q-py-xs items-center">
      <div class="col-6 col-lg-3">
        <q-input
          v-model="searchSync"
          dense
          label="Search"
          hint="Search by name, email, trading name or ABN"
          @keydown.enter="$emit('search')"
        />
      </div>

      <div class="col-6 col-lg-2">
        <q-select
          v-model="sortSync"
          dense
          label="Sort"
          :options="options"
          emit-value
          map-options
          hint="Sort user by account registration date"
        />
      </div>

      <div class="col-6 col-lg-2">
        <q-select
          v-model="verificationSync"
          dense
          label="Verification status"
          :options="verificationOptions"
          emit-value
          map-options
          hint="Sort user by verification status"
        />
      </div>

      <div class="col-6 col-lg-2">
        <q-select
          v-model="portSync"
          dense
          label="Operation Port"
          :options="ports"
          emit-value
          map-options
          hint="Filter user by operation port"
        />
      </div>

      <div class="col-6 col-lg-3 flex justify-between">
        <q-btn outline color="primary" label="reset" icon="cached" @click="$emit('reset')" />
        <q-btn color="primary" label="search" icon="search" @click="$emit('search')" />
      </div>
    </div>
  </div>
</template>

<script>
import cityApi from '@/apis/city.api';

export default {
  props: {
    search: {
      type: String,
      required: true,
    },
    sort: {
      type: String,
      required: true,
    },
    verification: {
      type: String,
      required: true,
    },
    port: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      options: [
        { label: 'Newest', value: '' },
        { label: 'Oldest', value: 'asc' },
      ],
      verificationOptions: [
        { label: 'All', value: '' },
        { label: 'Unverified', value: 'unverified' },
        { label: 'Pending', value: 'pending' },
        { label: 'Verified', value: 'verified' },
      ],
      ports: [],
    };
  },

  computed: {
    searchSync: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit('update:search', value);
      },
    },
    sortSync: {
      get() {
        return this.sort;
      },
      set(value) {
        this.$emit('update:sort', value);
      },
    },
    verificationSync: {
      get() {
        return this.verification;
      },
      set(value) {
        this.$emit('update:verification', value);
      },
    },
    portSync: {
      get() {
        return this.port;
      },
      set(value) {
        this.$emit('update:port', value);
      },
    },
  },
  async created() {
    // get ports
    const { data } = await cityApi.getCities();
    const ports = data.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));

    this.ports = [{ label: 'All', value: '' }, ...ports];
  },
};
</script>
